import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Вычисляет stageKey текущего этапа из URL для системы presence.
 *
 * /sales/stage1     → 'sales-stage1'
 * /purchase/stage1  → 'purchase-stage1'
 * /references/module2 → 'references-module2'
 *
 * Возвращает null если пользователь не на конкретном этапе.
 */
export function useCurrentStageKey(): string | null {
  const { pathname } = useLocation();

  return useMemo(() => {
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length < 2) return null;

    const [module, stage] = segments;

    if (module === 'sales' && stage?.startsWith('stage')) {
      return `sales-${stage}`;
    }
    if (module === 'purchase' && stage?.startsWith('stage')) {
      return `purchase-${stage}`;
    }
    if (module === 'references' && stage?.startsWith('module')) {
      return `references-${stage}`;
    }

    return null;
  }, [pathname]);
}
